import { defineStore } from 'pinia';
import axios from 'axios';

export const usePushNotificationStore = defineStore('pushNotifications', {
  state: () => ({
    VAPID_PUBLIC_KEY:
      'BB1wylvGVN_CJgJL14ekQoQmbshuffpFa0ZOU0t1Ld6BNVG5DM1yiXvHKAVVJCSEeQ4C-Del41gBOA76HYe3CaM'
  }),

  actions: {
    urlBase64ToUint8Array(base64String) {
      // ... existing urlBase64ToUint8Array function ...
    },

    async subscribe(sub) {
      const key = sub.getKey('p256dh');
      const token = sub.getKey('auth');
      const contentEncoding = (PushManager.supportedContentEncodings || [
        'aesgcm'
      ])[0];

      const data = {
        endpoint: sub.endpoint,
        public_key: key
          ? btoa(String.fromCharCode.apply(null, new Uint8Array(key)))
          : null,
        auth_token: token
          ? btoa(String.fromCharCode.apply(null, new Uint8Array(token)))
          : null,
        encoding: contentEncoding
      };

      try {
        await axios.post('/notifications/subscribe', JSON.stringify(data), {
          headers: { 'Content-Type': 'application/json' }
        });
      } catch (error) {
        console.error('Error:', error);
      }
    },

    async enablePushNotifications() {
      const registration = await navigator.serviceWorker.ready;
      let subscription = await registration.pushManager.getSubscription();

      if (!subscription) {
        const serverKey = this.urlBase64ToUint8Array(this.VAPID_PUBLIC_KEY);
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: serverKey
        });
      }

      if (subscription) {
        await this.subscribe(subscription);
      }
    },

    async disablePushNotifications() {
      // ... existing disablePushNotifications function ...
    },

    async requestBrowserNotification() {
      if (!('Notification' in window)) {
        return;
      }

      if (Notification.permission === 'granted') {
        await this.enablePushNotifications();
      } else if (Notification.permission !== 'denied') {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          await this.enablePushNotifications();
        }
      }
    },

    async checkNotificationPermission() {
      const permissionStatus = await navigator.permissions.query({
        name: 'notifications'
      });

      switch (permissionStatus.state) {
        case 'granted':
          break;
        case 'denied':
          break;
        default:
          await this.requestBrowserNotification();
          break;
      }
    }
  }
});
